import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../../store";
import ApiService from "../../../ApiService";
import DispatchProps from "../../../../utils/DispatchProps";
import MailroomGetPhotosResult, {MailroomPhoto} from "../../../../models/MailroomGetPhotosResult";
import {CommandBarButton, MessageBarType} from "office-ui-fabric-react";
import MailroomPhotoCard from "../../../mailroom/MailroomPhotoCard";
import MailroomDurableFunctionInstanceList from "../../../mailroom/MailroomDurableFunctionInstanceList";
import {DurableFunctionInstance} from "../../../../models/DurableFunctionInstance";
import {openFileDownload} from "../../../../utils/Utils";
import Actions from "../../../../redux/Actions";
import LoadingPage from "../../../LoadingPage";
import {UserAccessLevel, userAccessLevelIsAtLeast} from "../../../../models/UserAccessRecord";
import SchoolPageTitle from "../../../SchoolPageTitle";
import AdminSchoolMenu from "../../../AdminSchoolMenu";

interface ProcessorPreviewPhotosPageProps {
    tenantId: string;
    schoolCode: string;
    instanceId: string;

    usersCdbAccessLevel?: UserAccessLevel;
    apiService: ApiService;
    history: H.History,
}

interface ProcessorPreviewPhotosPageState {
    downloadInProgress: boolean;
    installInProgress: boolean;
    photosResult?: MailroomGetPhotosResult;
    instance?: DurableFunctionInstance;
}

class ProcessorPreviewPhotosPage extends Component<ProcessorPreviewPhotosPageProps & DispatchProps, ProcessorPreviewPhotosPageState> {

    constructor(props: ProcessorPreviewPhotosPageProps & DispatchProps) {
        super(props);

        this.state = {
            installInProgress: false,
            downloadInProgress: false,
            photosResult: undefined,
            instance: undefined,
        };
    }

    async componentDidUpdate(prevProps: Readonly<ProcessorPreviewPhotosPageProps & DispatchProps>, prevState: Readonly<ProcessorPreviewPhotosPageState>, snapshot?: any): Promise<void> {
        if (this.props.instanceId !== prevProps.instanceId) {
            await this.getInstanceAndPhotos()
        }
    }

    async componentDidMount() {
        await this.getInstanceAndPhotos()
    }
    
    private async getInstanceAndPhotos() {
        if (this.props.instanceId)
        {
            try {
                const instance = await this.props.apiService.getMailroomFunctionInstance(this.props.instanceId);
                this.setState({
                    instance
                });

                const photosResult = await this.props.apiService.getProcessorPhotos(this.props.instanceId);

                this.setState({
                    photosResult: photosResult,
                });
            } catch (err) {
                this.props.dispatch(Actions.showMessageBar("Failed to load photos " + err.message, MessageBarType.error));
            }
        }
    }
    
    private static buildPhotosSection(photoType: "Teacher" | "Student", photos: MailroomPhoto[])
    {
        return (
            <Fragment>
                <div className={"card"}>
                    <div className={"card__header"}>
                        <div className={"card__title"}>{photos.length} {photoType} Photos</div>
                    </div>
                    <div className={"flex-row flex--flow-wrap flex--justify-content-center"}>
                        {photos.map(tp => <MailroomPhotoCard mailroomPhoto={tp}/>)}
                    </div>
                </div>
            </Fragment>
        );
    }
    
    private downloadPhotosAsZip = async () => {
        try
        {
            this.setState({
                downloadInProgress: true
            });
            const result = await this.props.apiService.getProcessorPhotosZip(this.props.instanceId);
            await openFileDownload(result)
        }
        catch(e)
        {
            console.log(e)
            this.props.dispatch(Actions.showMessageBar("Failed to download photos " + e.message, MessageBarType.error));
        }
        
        this.setState({
            downloadInProgress: false
        });
    }
    
    render() {
        
        if(this.state.photosResult === undefined)
        {
            return (
                <LoadingPage/>
            );
        }
        
        
        let downloadPhotosButton = null;
        if (this.props.usersCdbAccessLevel && userAccessLevelIsAtLeast("admin", this.props.usersCdbAccessLevel)) {
            downloadPhotosButton = (
                <CommandBarButton
                    disabled={this.state.downloadInProgress}
                    iconProps={{ iconName: "DownloadDocument" }}
                    text="Download Photos Zip"
                    onClick={this.downloadPhotosAsZip}
                />
            );
        }
        
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Processor Preview Photos" />

                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                <MailroomDurableFunctionInstanceList title={"Instance"} columns={MailroomDurableFunctionInstanceList.processorColumns} additionalCellForColumn={MailroomDurableFunctionInstanceList.processorAdditionalCellForColumn} enableRowLinks={false} instances={this.state.instance ? [this.state.instance] : undefined} >
                    {downloadPhotosButton}
                </MailroomDurableFunctionInstanceList>
                
                {ProcessorPreviewPhotosPage.buildPhotosSection("Teacher",this.state.photosResult.teacherPhotos)}
                {ProcessorPreviewPhotosPage.buildPhotosSection("Student",this.state.photosResult.studentPhotos)}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): ProcessorPreviewPhotosPageProps => {

        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            instanceId: ownProps.match.params.instanceId,

            usersCdbAccessLevel: state.auth.usersCdbAccessLevel,
            
            apiService: state.auth.apiService,
            history: state.history
        };
    }
)(ProcessorPreviewPhotosPage);